export default __webpack_public_path__ + "static/media/pinstripe.17cc810b.png";